import { Grid, styled } from '@mui/material';
import { Fragment } from 'react';

import IEReportTable from './shared/Income-Expense-ReportTable';

const ContentBox = styled('div')(({ theme }) => ({
  margin: '30px',
  [theme.breakpoints.down('sm')]: { margin: '16px' }
}));

const IEReport = () => {
  return (
    <Fragment>
      <ContentBox className='analytics'>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <IEReportTable />
          </Grid>
        </Grid>
      </ContentBox>
    </Fragment>
  );
};

export default IEReport;
